module.exports = __webpack_public_path__ + "img/video-20.5f2947d6.png";